import { EDITOR_EMOJI_CLUSTER_ATTR } from '@/utils/editor-text-box/editorTextBoxAdapter'
import type { EditorGlyphSource } from '@/utils/editor-text-box/editorTextBoxAdapter'

/**
 * The element of the tallest run a box's glyphs paint in, whose computed
 * font the geometry probe reports as the box's text font. An emoji
 * cluster's span paints the emoji family ahead of its run's stack, so it is
 * left out; the run's text spans carry the run's own family. Null when no
 * glyph paints outside an emoji cluster.
 */
export const tallestRunElementOf = (
  sources: readonly EditorGlyphSource[],
): Element | null => {
  let tallest: Element | null = null
  let tallestPx = -1
  for (const { node } of sources) {
    const el = node.parentElement
    if (!el || el.hasAttribute(EDITOR_EMOJI_CLUSTER_ATTR)) continue
    const sizePx = Number.parseFloat(getComputedStyle(el).fontSize)
    if (!(sizePx > tallestPx)) continue
    tallestPx = sizePx
    tallest = el
  }
  return tallest
}
